const production: boolean = true;

export const environment = {
  production: production,
  logo: "/assets/images/logo.png",
  endpoint: "https://ckfunding-api.tech4broker.online/client",
  profile_image_path: "https://ckfunding-api.tech4broker.online/uploads/profile_img/",
  doc_image_path: "https://ckfunding-api.tech4broker.online/uploads/documents/",
  finance_image_path: "https://ckfunding-api.tech4broker.online/uploads/finance/",
  ib: "https://ib.cktrading.co",
  logo_width: 120,
  inner_logo_width: 80,
  windows_platform:
    "https://www.dropbox.com/scl/fi/cgeynwo79u9dvs7j3yhja/AOne.mt5.terminal.setup-3-1.exe?rlkey=s3v9kx1zrw28niif5devgmhac&st=kanx8wu0&dl=1",
  android_platform:
    "https://download2271.mediafire.com/v3wv1qi4k2ag1v4qPBeHptDV2Xua5zJcStMgH7R3OVNWWNG0Zpb2tOIocIP0smMRJwwnPXra1GZ2XJG3MrqIGDmILNi1mqRK3l6ga8IzLo7jmH_ujvY06yDkhhCpceHoAOvNrR_purC9cdQ5f4HN9efVd1ru0OAVrdz_fityzw/934yc4ar3dy0xw0/meta5pro+%283%29.apk",
  ios_platform:
    "https://download-aone-apps.vercel.app",
  huawei: "#",
};